import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "content"
}
const _hoisted_2 = { class: "grid" }
const _hoisted_3 = { class: "inputs" }
const _hoisted_4 = { class: "inputs" }
const _hoisted_5 = { class: "inputs" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "results" }
const _hoisted_9 = { class: "table-content" }
const _hoisted_10 = { class: "results" }
const _hoisted_11 = { class: "table-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderDots = _resolveComponent("LoaderDots")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[13] || (_cache[13] = _createElementVNode("h1", { class: "result-title" }, "Credit and free entries", -1)),
    (_ctx.freeEntriesCreditBalance)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[5] || (_cache[5] = _createElementVNode("label", null, "Free Entries Balance:", -1)),
              _withDirectives(_createElementVNode("input", {
                disabled: "",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.freeEntries) = $event)),
                readonly: ""
              }, null, 512), [
                [_vModelText, _ctx.freeEntries]
              ])
            ]),
            _withDirectives(_createElementVNode("select", {
              class: "dropdown",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedOption) = $event))
            }, _cache[6] || (_cache[6] = [
              _createElementVNode("option", {
                disabled: "",
                value: null
              }, "Select", -1),
              _createElementVNode("option", {
                key: "FreeEntries",
                value: "FreeEntries"
              }, "Free Entries", -1),
              _createElementVNode("option", {
                key: "CompetitionCredit",
                value: "CompetitionCredit"
              }, " Competition Credit ", -1)
            ]), 512), [
              [_vModelSelect, _ctx.selectedOption]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _cache[7] || (_cache[7] = _createElementVNode("label", null, "Competition Credit Balance:", -1)),
              _withDirectives(_createElementVNode("input", {
                disabled: "",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.creditBalance) = $event)),
                readonly: ""
              }, null, 512), [
                [_vModelText, _ctx.creditBalance]
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[8] || (_cache[8] = _createElementVNode("label", { for: "amount" }, [
                _createElementVNode("strong", null, "Amount:")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                id: "amount",
                name: "amount",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.amount) = $event)),
                placeholder: "Enter amount"
              }, null, 512), [
                [_vModelText, _ctx.amount]
              ])
            ]),
            _createElementVNode("button", {
              disabled: _ctx.isSubmitting,
              class: "btn",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addFreeEntriesOrCreditBalance && _ctx.addFreeEntriesOrCreditBalance(...args)))
            }, [
              (!_ctx.isSubmitting)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Add"))
                : _createCommentVNode("", true),
              (_ctx.isSubmitting)
                ? (_openBlock(), _createBlock(_component_LoaderDots, { key: 1 }))
                : _createCommentVNode("", true)
            ], 8, _hoisted_6)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "result-title" }, "Credit Transactions", -1)),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("table", null, [
          _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
            _createElementVNode("tr", { class: "table-header" }, [
              _createElementVNode("th", null, "Transaction Id"),
              _createElementVNode("th", null, "Action"),
              _createElementVNode("th", null, "Order No"),
              _createElementVNode("th", null, "Admin User"),
              _createElementVNode("th", null, "Amount"),
              _createElementVNode("th", null, "Date"),
              _createElementVNode("th", null, "Expiry Date")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.freeEntriesCreditTransactions?.userCreditTransactions, (creditTransaction) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "table-row",
                key: creditTransaction.transactionId
              }, [
                _createElementVNode("td", null, _toDisplayString(creditTransaction.transactionId), 1),
                _createElementVNode("td", null, _toDisplayString(creditTransaction.action), 1),
                _createElementVNode("td", null, _toDisplayString(creditTransaction.orderNo), 1),
                _createElementVNode("td", null, _toDisplayString(creditTransaction.adminUser), 1),
                _createElementVNode("td", null, _toDisplayString(creditTransaction.amount.toFixed(2)), 1),
                _createElementVNode("td", null, _toDisplayString(creditTransaction.date), 1),
                _createElementVNode("td", null, _toDisplayString(creditTransaction.expiryDate), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "result-title" }, "Free Entry Transactions", -1)),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("table", null, [
          _cache[11] || (_cache[11] = _createElementVNode("thead", null, [
            _createElementVNode("tr", { class: "table-header" }, [
              _createElementVNode("th", null, "Transaction Id"),
              _createElementVNode("th", null, "Action"),
              _createElementVNode("th", null, "Order No"),
              _createElementVNode("th", null, "Admin User"),
              _createElementVNode("th", null, "Amount"),
              _createElementVNode("th", null, "Date"),
              _createElementVNode("th", null, "Expiry Date")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.freeEntriesCreditTransactions?.userFreeEntryTransactions, (freeEntryTransaction) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "table-row",
                key: freeEntryTransaction.transactionId
              }, [
                _createElementVNode("td", null, _toDisplayString(freeEntryTransaction.transactionId), 1),
                _createElementVNode("td", null, _toDisplayString(freeEntryTransaction.action), 1),
                _createElementVNode("td", null, _toDisplayString(freeEntryTransaction.orderNo), 1),
                _createElementVNode("td", null, _toDisplayString(freeEntryTransaction.adminUser), 1),
                _createElementVNode("td", null, _toDisplayString(freeEntryTransaction.amount.toFixed(2)), 1),
                _createElementVNode("td", null, _toDisplayString(freeEntryTransaction.date), 1),
                _createElementVNode("td", null, _toDisplayString(freeEntryTransaction.expiryDate), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 64))
}